import React from "react";
import { IEmailAIExtractedData } from "@/types/common";
import { formatDateToString } from "@/utils/date";
import {
  ENTITY_STATUS,
  LEGAL_ENTITY_TYPE,
  REVIEW_STATUS,
} from "@/constants/common";
import ExtractedDataList from "./ExtractedDataList";

interface EmailAiExtractedDataDialogProps {
  emailAiExtractedData: IEmailAIExtractedData;
}

const MainInformation = ({
  emailAiExtractedData,
}: EmailAiExtractedDataDialogProps) => {
  if (!emailAiExtractedData) return null;

  const {
    businessName,
    dba,
    address,
    city,
    state,
    zipCode,
    taxId,
    entityId,
    legalEntityType,
    businessStartDate,
    createdAt,
    confidenceScore,
    reviewStatus,
    stateUrl,
    otherLegalEntityType,
    entityStatus,
    businessPhone,
  } = emailAiExtractedData;

  const legalEntity = LEGAL_ENTITY_TYPE.find(
    (item) => item.value === `${legalEntityType}`,
  );
  const legalEntityLabel = legalEntity
    ? legalEntity.label === "Other"
      ? `${legalEntity.label} (${otherLegalEntityType})`
      : legalEntity.label
    : (legalEntityType ?? "");

  const eStatus = ENTITY_STATUS.find(
    (item) => item.value === `${entityStatus}`,
  );
  const entityStatusLabel = eStatus ? eStatus.label : (entityStatus ?? "");
  const listData = [
    { label: "Business name", value: businessName },
    { label: "DBA", value: dba },
    { label: "Address", value: address },
    { label: "City", value: city },
    { label: "State", value: state },
    { label: "Zip code", value: zipCode },
    { label: "Tax Id", value: taxId },
    { label: "Entity Id", value: entityId },
    { label: "Business phone", value: businessPhone },
    { label: "Legal entity id", value: legalEntityLabel },
    { label: "Status", value: entityStatusLabel },
    {
      label: "Business start date",
      value: formatDateToString(businessStartDate),
    },
    { label: "Created at", value: formatDateToString(createdAt) },
    { label: "Confidence score", value: confidenceScore },
    { label: "Review status", value: REVIEW_STATUS[reviewStatus] ?? "" },
    { label: "State url", value: stateUrl },
  ];

  return <ExtractedDataList listData={listData} />;
};

export default MainInformation;
